(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[120],{

/***/ 561:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(582);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ VideoLazyLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

function VideoLazyLoad() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        !function() {
            var e = [].slice.call(document.querySelectorAll("video.lazy"));
            if ("IntersectionObserver" in window) {
                var r = new IntersectionObserver(function(e, t) {
                    e.forEach(function(e) {
                        if (e.isIntersecting) {
                            for(var t in e.target.children){
                                var a = e.target.children[t];
                                "string" == typeof a.tagName && "SOURCE" === a.tagName && (a.src = a.dataset.src);
                            }
                            e.target.load(), e.target.classList.remove("lazy"), r.unobserve(e.target);
                        }
                    });
                });
                e.forEach(function(e) {
                    r.observe(e);
                });
            }
        }();
    }, []);
};


/***/ }),

/***/ 582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/future/image.js
var future_image = __webpack_require__(1723);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(42);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../@hiredigital/ui/src/Text/Text.jsx
var Text = __webpack_require__(966);
// EXTERNAL MODULE: ./src/lib/videoLazyload.jsx
var videoLazyload = __webpack_require__(4793);
// EXTERNAL MODULE: ./src/components/Footer/ClientFooter.jsx + 6 modules
var ClientFooter = __webpack_require__(1977);
// EXTERNAL MODULE: ./src/components/Header/AbmHeader.jsx + 3 modules
var AbmHeader = __webpack_require__(3544);
// EXTERNAL MODULE: ./src/components/Layout/BaseLayout.jsx + 3 modules
var BaseLayout = __webpack_require__(7263);
// EXTERNAL MODULE: ./src/components/Section/Container.jsx
var Container = __webpack_require__(7839);
// EXTERNAL MODULE: ./src/components/Section/Section.jsx
var Section = __webpack_require__(863);
// EXTERNAL MODULE: ./src/components/Abm/Button.jsx + 1 modules
var Button = __webpack_require__(9953);
// EXTERNAL MODULE: ./src/components/Link.jsx
var Link = __webpack_require__(305);
// EXTERNAL MODULE: ./src/components/Abm/Styles.module.scss
var Styles_module = __webpack_require__(3320);
var Styles_module_default = /*#__PURE__*/__webpack_require__.n(Styles_module);
;// CONCATENATED MODULE: ./src/components/Abm/AgencyCardSection.jsx








var ExpertTalentItem = function(param) {
    var card = param.card;
    var ref;
    var title = (ref = card.title) === null || ref === void 0 ? void 0 : ref.split("\n").map(function(e) {
        return e.trim();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Styles_module_default()).card,
        children: [
            card.imageOrIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                loading: "lazy",
                className: (Styles_module_default()).cardIcon,
                src: card.imageOrIcon.url,
                alt: "icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (Styles_module_default()).cardTitle,
                children: title[0]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: (Styles_module_default()).cardSubtitle,
                children: title[1]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Styles_module_default()).cardDesc,
                children: [
                    card.description,
                    card.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Styles_module_default()).cardLogo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            loading: "lazy",
                            src: "/logos/white-cropped/".concat(card.logo, ".svg"),
                            alt: card.logo
                        })
                    })
                ]
            })
        ]
    });
};
var AgencyCardItem = function(param) {
    var card = param.card;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Styles_module_default()).card,
        children: [
            card.imageOrIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                loading: "lazy",
                className: (Styles_module_default()).cardIcon,
                src: card.imageOrIcon.url,
                alt: "icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (Styles_module_default()).cardTitle,
                children: card.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (Styles_module_default()).cardDesc,
                children: [
                    card.description,
                    card.linkText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "https://hiredigital.com/",
                        className: (Styles_module_default()).cardLink,
                        children: card.linkText
                    })
                ]
            }),
            card.sidebarTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (Styles_module_default()).sidebarTitle,
                        children: card.sidebarTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((Styles_module_default()).sidebarList, card.sidebarList.length <= 7 && (Styles_module_default()).fewItemsOnly),
                        children: card.sidebarList.map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: item
                            }, i);
                        })
                    })
                ]
            })
        ]
    });
};
var AgencyCardSection = function(param) {
    var section = param.section, ind = param.ind;
    var style = section.cardStyle;
    var cardAnchor = style;
    switch(style){
        case "Expertise":
        case "Digital_Expertise":
        case "Solutions":
            cardAnchor = "Our_Expertise";
            break;
        case "Expert_Talents":
            cardAnchor = "Our_People";
            break;
    }
    switch(style){
        case "Expertise":
        case "Proposed_Team":
        case "Expert_Talents":
        case "Digital_Expertise":
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: classnames_default()((Styles_module_default()).container, (Styles_module_default()).cardContainer, (Styles_module_default())[style]),
                anchor: cardAnchor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
                    className: (Styles_module_default()).cardSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: (Styles_module_default()).sectionTitle,
                            children: section === null || section === void 0 ? void 0 : section.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: (Styles_module_default()).sectionDescription,
                            children: section === null || section === void 0 ? void 0 : section.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Styles_module_default()).cardRowContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((Styles_module_default()).cardRow),
                                children: section === null || section === void 0 ? void 0 : section.cards.map(function(card, index) {
                                    return style === "Expert_Talents" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertTalentItem, {
                                        card: card
                                    }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyCardItem, {
                                        card: card
                                    }, index);
                                })
                            })
                        }),
                        (section === null || section === void 0 ? void 0 : section.ctaButton) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Styles_module_default()).cardCtaButton,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: section === null || section === void 0 ? void 0 : section.ctaText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: (Styles_module_default()).button,
                                    button: section === null || section === void 0 ? void 0 : section.ctaButton
                                })
                            ]
                        })
                    ]
                })
            }, ind);
    }
};
/* harmony default export */ var Abm_AgencyCardSection = (AgencyCardSection);

;// CONCATENATED MODULE: ../@hiredigital/ui/src/Icon/icons/add.inline.svg
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgAddinline = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/react.createElement("path", {
  d: "M2.5 10h15M10 17.5v-15"
}))));

/* harmony default export */ var add_inline = (SvgAddinline);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/Icon/icons/deduct.inline.svg
var deduct_inline_g;

function deduct_inline_extends() { deduct_inline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return deduct_inline_extends.apply(this, arguments); }



const SvgDeductinline = props => /*#__PURE__*/react.createElement("svg", deduct_inline_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), deduct_inline_g || (deduct_inline_g = /*#__PURE__*/react.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/react.createElement("path", {
  d: "M2.5 10h15"
}))));

/* harmony default export */ var deduct_inline = (SvgDeductinline);
;// CONCATENATED MODULE: ./src/components/Abm/AgencyCaseSection.jsx











var AgencyCaseItemTitle = function(param) {
    var caseStudy = param.caseStudy;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                className: (Styles_module_default()).caseTitle,
                children: caseStudy === null || caseStudy === void 0 ? void 0 : caseStudy.title
            }),
            (caseStudy === null || caseStudy === void 0 ? void 0 : caseStudy.subtitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Styles_module_default()).caseReadMore,
                children: caseStudy === null || caseStudy === void 0 ? void 0 : caseStudy.subtitle
            })
        ]
    });
};
var AgencyCaseItem = function(param) {
    var caseStudy = param.caseStudy;
    var ref;
    var ref1 = (0,react.useState)(false), showDetails = ref1[0], setShowDetails = ref1[1];
    var handleToggleClick = function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setShowDetails(!showDetails);
    };
    var linkContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: (Styles_module_default()).caseImage,
                src: caseStudy === null || caseStudy === void 0 ? void 0 : (ref = caseStudy.image) === null || ref === void 0 ? void 0 : ref.url,
                alt: "Case Study Image",
                fill: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Styles_module_default()).caseContentSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyCaseItemTitle, {
                    caseStudy: caseStudy
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Styles_module_default()).caseToggle,
                onClick: handleToggleClick,
                children: showDetails ? /*#__PURE__*/ (0,jsx_runtime.jsx)(deduct_inline, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(add_inline, {})
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Styles_module_default()).caseItemContainer,
        children: [
            (caseStudy === null || caseStudy === void 0 ? void 0 : caseStudy.pageCaseStudy) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                className: classnames_default()((Styles_module_default()).caseItem, (Styles_module_default()).caseLink),
                href: "/case-studies/".concat(caseStudy.pageCaseStudy.slug),
                children: linkContent
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Styles_module_default()).caseItem,
                children: linkContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(showDetails && (Styles_module_default()).isDetailsVisible, (Styles_module_default()).caseDetails),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Styles_module_default()).caseDescription,
                        children: caseStudy === null || caseStudy === void 0 ? void 0 : caseStudy.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Styles_module_default()).caseChallenge,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Styles_module_default()).caseHeader,
                                children: "Challenge"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Styles_module_default()).caseContent,
                                children: caseStudy === null || caseStudy === void 0 ? void 0 : caseStudy.challenge
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Styles_module_default()).caseSolution,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Styles_module_default()).caseHeader,
                                children: "Solution"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Styles_module_default()).caseContent,
                                children: caseStudy === null || caseStudy === void 0 ? void 0 : caseStudy.solution
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Styles_module_default()).caseTeamStructure,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Styles_module_default()).caseHeader,
                                children: "Team Structure"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Styles_module_default()).caseTeamStructureContainer,
                                children: caseStudy === null || caseStudy === void 0 ? void 0 : caseStudy.teamStructure.map(function(team, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Styles_module_default()).caseContent,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: team === null || team === void 0 ? void 0 : team.html
                                            }
                                        })
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var AgencyCaseSection = function(param) {
    var section = param.section, ind = param.ind;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classnames_default()((Styles_module_default()).container, (Styles_module_default()).caseContainer),
        anchor: "Case_Studies",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
            className: (Styles_module_default()).caseSection,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    className: (Styles_module_default()).sectionTitle,
                    children: section === null || section === void 0 ? void 0 : section.title
                }),
                section === null || section === void 0 ? void 0 : section.caseStudies.map(function(caseStudy, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyCaseItem, {
                        caseStudy: caseStudy
                    }, i);
                })
            ]
        })
    }, ind);
};
/* harmony default export */ var Abm_AgencyCaseSection = (AgencyCaseSection);

;// CONCATENATED MODULE: ./src/components/Abm/AgencyCtaSection.jsx








var AgencyCtaSection = function(param) {
    var section = param.section, ind = param.ind;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classnames_default()((Styles_module_default()).container, (Styles_module_default()).ctaContainer, (Styles_module_default())[section.ctaStyle]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
            className: (Styles_module_default()).ctaSection,
            style: section.ctaStyle == "Prefer_On_Demand" && section.image ? {
                backgroundImage: "url(".concat(section.image.url, ")")
            } : {},
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: (Styles_module_default()).sectionTitle,
                            children: section === null || section === void 0 ? void 0 : section.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: (Styles_module_default()).sectionDescription,
                            children: section === null || section === void 0 ? void 0 : section.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Styles_module_default()).ctaButtons,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    button: section.button1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    button: section.button2
                                })
                            ]
                        })
                    ]
                }),
                section.ctaStyle == "Trained_by_Experts" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Styles_module_default()).ctaImageContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: (Styles_module_default()).ctaImage,
                        src: section.image.url,
                        width: section.image.width,
                        height: section.image.height,
                        alt: section.title
                    })
                })
            ]
        })
    }, ind);
};
/* harmony default export */ var Abm_AgencyCtaSection = (AgencyCtaSection);

// EXTERNAL MODULE: ./src/shared/helpers/utils.js
var utils = __webpack_require__(8456);
;// CONCATENATED MODULE: ./src/components/Abm/AgencyInsightsSection.jsx








var AgencyInsightsSection = function(param) {
    var section = param.section, ind = param.ind;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classnames_default()((Styles_module_default()).container, (Styles_module_default()).insightContainer),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
            className: (Styles_module_default()).insightSection,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    className: (Styles_module_default()).sectionTitle,
                    children: section === null || section === void 0 ? void 0 : section.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Styles_module_default()).insightRowContainer,
                    children: section === null || section === void 0 ? void 0 : section.insights.map(function(insight, index) {
                        var d = new Date(insight.date);
                        var dF = "".concat(d.getDate(), " ").concat(utils/* months */.e7[d.getMonth()], "'").concat(String(d.getFullYear()).substring(2));
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            href: insight.url,
                            className: (Styles_module_default()).insightRow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Styles_module_default()).insightHeading, (Styles_module_default())[insight.type]),
                                    children: [
                                        insight.type,
                                        " • ",
                                        dF
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (Styles_module_default()).insightContent,
                                    children: insight.title
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    }, ind);
};
/* harmony default export */ var Abm_AgencyInsightsSection = (AgencyInsightsSection);

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(5963);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(9312);
// EXTERNAL MODULE: ./src/components/Registration/common/helpers.js
var helpers = __webpack_require__(1344);
// EXTERNAL MODULE: ./src/shared/helpers/forms.js
var helpers_forms = __webpack_require__(3601);
// EXTERNAL MODULE: ../@hiredigital/ui/src/Input/SimpleTextInput.jsx
var SimpleTextInput = __webpack_require__(8920);
// EXTERNAL MODULE: ./src/components/Abm/Button.module.scss
var Button_module = __webpack_require__(8593);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./src/components/Abm/WebinarForm.jsx












var WebinarForm = function(param) {
    var submit = param.submit;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), submitted = ref1[0], setSubmitted = ref1[1];
    var ref2 = (0,react.useState)(false), processed = ref2[0], setProcessed = ref2[1];
    var ref3 = (0,react.useState)(""), fullName = ref3[0], setFullName = ref3[1];
    var ref4 = (0,react.useState)(""), email = ref4[0], setEmail = ref4[1];
    var ref5 = (0,react.useState)(""), title = ref5[0], setTitle = ref5[1];
    var ref6 = (0,react.useState)(false), emailValid = ref6[0], setEmailValid = ref6[1];
    var ref7 = (0,react.useState)(false), corporateValid = ref7[0], setCorporateValid = ref7[1];
    (0,react.useEffect)(function() {
        setProcessed(false);
    }, [
        fullName,
        email,
        title
    ]);
    (0,react.useEffect)(function() {
        setEmailValid(true);
        setCorporateValid(true);
    }, [
        email
    ]);
    var checkEmail = function() {
        var validator = (0,helpers_forms/* validateCorporateAndValidEmail */.hi)(email);
        setEmailValid(validator.valid);
        setCorporateValid(validator.corporate);
        return validator.valid && validator.corporate;
    };
    var handleKeyPress = function(e) {
        if (e.key === "Enter") {
            handleSubmit(e);
        }
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, firstName, lastName, domain, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                e.preventDefault();
                e.stopPropagation();
                _tmp = {};
                if (!!email && checkEmail()) {
                    setSubmitted(false);
                    setLoading(true);
                    ref = (0,helpers_forms/* getNameParts */.$N)(fullName), firstName = ref.firstName, lastName = ref.lastName;
                    domain = (0,helpers_forms/* getEmailDomain */.Gd)(email);
                    try {
                        (0,helpers/* submitHubspotForm */.WJ)("91f36dcd-ea16-4781-a698-79581f95631d", window.location.href, document.title, (_tmp.email = email, _tmp.work_email = email, _tmp.firstname = firstName, _tmp.lastname = lastName, _tmp.company = domain, _tmp.jobtitle = title, _tmp.form_type = "Webinar", _tmp)).then(function(response) {
                            var ref;
                            if (!response) return;
                            if ((0,_instanceof/* default */.Z)(response, Error)) throw response;
                            if (((ref = response.data) === null || ref === void 0 ? void 0 : ref.inlineMessage) === "Thanks for submitting the form.") {
                                setLoading(false);
                                setProcessed(true);
                            }
                        });
                    } catch (err) {
                        console.error(err);
                    }
                } else {
                    setSubmitted(true);
                }
                return [
                    2
                ];
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEmailBlur = function() {
        checkEmail();
    };
    var validateEmail = function() {
        if (submitted && !email) {
            return "Enter your email address";
        } else if (email) {
            if (!emailValid) {
                return "Enter a valid email address";
            } else if (!corporateValid) {
                return "Please enter your work email address";
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTextInput/* default */.Z, {
                className: (Styles_module_default()).webinarInput,
                name: "fullName",
                label: "Your Name",
                defaultValue: fullName,
                onKeyPress: handleKeyPress,
                onChange: function(e) {
                    return setFullName(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTextInput/* default */.Z, {
                className: (Styles_module_default()).webinarInput,
                name: "email",
                label: "Work Email",
                error: validateEmail(),
                defaultValue: email,
                onKeyPress: handleKeyPress,
                onBlur: handleEmailBlur,
                onChange: function(e) {
                    return setEmail(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTextInput/* default */.Z, {
                className: (Styles_module_default()).webinarInput,
                name: "title",
                label: "Title",
                defaultValue: title,
                onKeyPress: handleKeyPress,
                onChange: function(e) {
                    return setTitle(e.target.value);
                }
            }),
            processed ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Styles_module_default()).webinarMessage),
                children: submit.url
            }) : loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Button_module_default()).button, (Styles_module_default()).webinarMessage),
                children: "Submitting..."
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (Styles_module_default()).button,
                button: {
                    url: "#",
                    label: submit.label
                },
                onClick: handleSubmit
            })
        ]
    });
};
/* harmony default export */ var Abm_WebinarForm = (WebinarForm);

;// CONCATENATED MODULE: ./src/components/Abm/AgencyLearnSection.jsx







var AgencyLearnSection = function(param) {
    var section = param.section, ind = param.ind;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classnames_default()((Styles_module_default()).container, (Styles_module_default()).learnContainer),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
            className: (Styles_module_default()).learnSection,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Styles_module_default()).learnGrid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                className: (Styles_module_default()).sectionTitle,
                                children: section === null || section === void 0 ? void 0 : section.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                className: (Styles_module_default()).sectionSubtitle,
                                children: section === null || section === void 0 ? void 0 : section.subtitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Styles_module_default()).sectionDescription,
                                dangerouslySetInnerHTML: {
                                    __html: section === null || section === void 0 ? void 0 : (ref = section.description) === null || ref === void 0 ? void 0 : ref.html
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Styles_module_default()).learnRowContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Styles_module_default()).learnRow),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            className: (Styles_module_default()).learnRowTitle,
                                            children: "Speakers"
                                        }),
                                        section === null || section === void 0 ? void 0 : section.speakers.map(function(speaker, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Styles_module_default()).learnSpeakerName,
                                                        children: speaker.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Styles_module_default()).learnSpeakerRole,
                                                        children: speaker.role
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Styles_module_default()).learnSpeakerCompany,
                                                        children: speaker.company
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Styles_module_default()).learnSpeakerBlurb,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: speaker.blurb
                                                        })
                                                    })
                                                ]
                                            }, index);
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Styles_module_default()).learnWebinar,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Styles_module_default()).webinarImageContainer,
                                style: section.webinarCardHeroImage ? {
                                    backgroundImage: "url(".concat(section.webinarCardHeroImage.url, ")")
                                } : {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Styles_module_default()).webinarTitle,
                                    children: section.webinarCardTitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Abm_WebinarForm, {
                                submit: section.webinarCardButton
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Styles_module_default()).webinarPrivacyAgreement,
                                dangerouslySetInnerHTML: {
                                    __html: (ref1 = section.webinarCardFooter) === null || ref1 === void 0 ? void 0 : ref1.html
                                }
                            })
                        ]
                    })
                ]
            })
        })
    }, ind);
};
/* harmony default export */ var Abm_AgencyLearnSection = (AgencyLearnSection);

// EXTERNAL MODULE: ./src/components/Abm/AgencyLogoSection.jsx + 6 modules
var AgencyLogoSection = __webpack_require__(7391);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(3218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/Abm/AgencyTalentsSection.jsx








var AgencyTalentsSection = function(param) {
    var section = param.section, ind = param.ind;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classnames_default()((Styles_module_default()).container, (Styles_module_default()).talentContainer),
        anchor: "Our_People",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
            className: (Styles_module_default()).talentSection,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    className: (Styles_module_default()).sectionTitle,
                    children: section === null || section === void 0 ? void 0 : section.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    className: (Styles_module_default()).sectionDescription,
                    children: section === null || section === void 0 ? void 0 : section.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "talentRowContainer",
                    className: (Styles_module_default()).talentRowContainer,
                    tabIndex: 0,
                    children: section === null || section === void 0 ? void 0 : section.talents.map(function(talent, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Styles_module_default()).talentRow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    className: (Styles_module_default()).talentPicture,
                                    src: talent.icon.url,
                                    alt: talent.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Styles_module_default()).talentHeading,
                                    children: talent.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Styles_module_default()).talentContent,
                                    children: talent.description.text
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "adjustTalentRowContainer",
                    children: "document.getElementById('talentRowContainer').scrollLeft = 95"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Styles_module_default()).talentButtons,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            button: section.button1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            button: section.button2
                        })
                    ]
                })
            ]
        })
    }, ind);
};
/* harmony default export */ var Abm_AgencyTalentsSection = (AgencyTalentsSection);

// EXTERNAL MODULE: ../node_modules/@contentco/react-scroll-snap-slider/dist/module.js + 3 modules
var dist_module = __webpack_require__(4591);
;// CONCATENATED MODULE: ./src/components/Abm/AgencyTestimonialSection.jsx









var AgencyTestimonialSection = function(param) {
    var section = param.section, ind = param.ind;
    var sliderRef = (0,react.useRef)();
    var ref = (0,react.useState)(0), slideIndex = ref[0], setSlideIndex = ref[1];
    var lastSlideIndex = (section === null || section === void 0 ? void 0 : section.testimonials.length) - 1;
    var sliderNavigate = function(e, direction) {
        e.preventDefault();
        e.stopPropagation();
        var slider = sliderRef.current;
        switch(direction){
            case "prev":
                if (slideIndex === 0) slider.scrollToSlide(lastSlideIndex);
                else slider.scrollToSlide(slideIndex - 1);
                break;
            case "next":
                if (slideIndex === lastSlideIndex) slider.scrollToSlide(0);
                else slider.scrollToSlide(slideIndex + 1);
                break;
        }
    };
    var sliderNext = function(e) {
        return sliderNavigate(e, "next");
    };
    var sliderPrev = function(e) {
        return sliderNavigate(e, "prev");
    };
    var style = section.testimonialStyle;
    switch(style){
        case "Ad_Landing_Schedule_Call":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: classnames_default()((Styles_module_default()).container, (Styles_module_default()).testimonialContainer, (Styles_module_default())[style]),
                style: section.backgroundImage ? {
                    backgroundImage: "url(".concat(section.backgroundImage.url, ")")
                } : {},
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
                    className: (Styles_module_default()).testimonialSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: (Styles_module_default()).sectionTitle,
                            children: section === null || section === void 0 ? void 0 : section.title
                        }),
                        section === null || section === void 0 ? void 0 : section.testimonials.map(function(testimonial, i) {
                            var ref;
                            if (i > 0) return; // intentional for Ad_Landing_Schedule_Call
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Styles_module_default()).testimonialContent,
                                children: [
                                    (testimonial === null || testimonial === void 0 ? void 0 : testimonial.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Styles_module_default()).testimonialNameContainer,
                                        children: [
                                            (testimonial === null || testimonial === void 0 ? void 0 : testimonial.photo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (Styles_module_default()).testimonialImage,
                                                src: testimonial === null || testimonial === void 0 ? void 0 : (ref = testimonial.photo) === null || ref === void 0 ? void 0 : ref.url,
                                                alt: "Testimonial Image",
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Styles_module_default()).testimonialNameContent,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        className: (Styles_module_default()).testimonialName,
                                                        children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        className: (Styles_module_default()).testimonialRole,
                                                        children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.role
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        className: (Styles_module_default()).testimonialCompany,
                                                        children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.company
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        className: (Styles_module_default()).testimonialTitle,
                                        children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.quote
                                    })
                                ]
                            }, i);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Styles_module_default()).testimonialButtons,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    button: section.button1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    button: section.button2,
                                    isSecondary: true
                                })
                            ]
                        })
                    ]
                })
            }, ind);
        case "Home_Page_About_Us":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: classnames_default()((Styles_module_default()).container, (Styles_module_default()).testimonialContainer, (Styles_module_default())[style]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
                    className: (Styles_module_default()).testimonialSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: (Styles_module_default()).sectionTitle,
                            children: section === null || section === void 0 ? void 0 : section.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Styles_module_default()).testimonialGrid,
                            children: section === null || section === void 0 ? void 0 : section.testimonials.map(function(testimonial, i) {
                                var ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Styles_module_default())["testimonial".concat(i + 1)],
                                    children: [
                                        (testimonial === null || testimonial === void 0 ? void 0 : testimonial.logo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (Styles_module_default()).agencyLogo,
                                            loading: "lazy",
                                            src: "/logos/white-cropped/".concat(testimonial.logo, ".svg"),
                                            alt: testimonial.logo
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            className: (Styles_module_default()).testimonialTitle,
                                            children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.quote
                                        }),
                                        (testimonial === null || testimonial === void 0 ? void 0 : testimonial.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Styles_module_default()).testimonialNameContainer,
                                            children: [
                                                (testimonial === null || testimonial === void 0 ? void 0 : testimonial.photo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: (Styles_module_default()).testimonialImage,
                                                    src: testimonial === null || testimonial === void 0 ? void 0 : (ref = testimonial.photo) === null || ref === void 0 ? void 0 : ref.url,
                                                    alt: "Testimonial Image",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Styles_module_default()).testimonialNameContent,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            className: (Styles_module_default()).testimonialName,
                                                            children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            className: (Styles_module_default()).testimonialRole,
                                                            children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.role
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            className: (Styles_module_default()).testimonialCompany,
                                                            children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.company
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        })
                    ]
                })
            }, ind);
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: classnames_default()((Styles_module_default()).container, (Styles_module_default()).testimonialContainer, (Styles_module_default()).testimonialDefault),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
                    className: (Styles_module_default()).testimonialSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: (Styles_module_default()).sectionTitle,
                            children: [
                                section === null || section === void 0 ? void 0 : section.title,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (Styles_module_default()).testimonialArrows,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            className: (Styles_module_default()).testimonialArrowLeft,
                                            onClick: sliderPrev,
                                            ariaLabel: "Previous Slide"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            className: (Styles_module_default()).testimonialArrowRight,
                                            onClick: sliderNext,
                                            ariaLabel: "Next Slide"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* Slider */.iR, {
                            ref: sliderRef,
                            onSlidesVisibilityChange: function(i) {
                                return setSlideIndex(i);
                            },
                            slidesPerPageSettings: {
                                mobileSmall: 1,
                                mobileBig: 1,
                                tablet: 1,
                                desktop: 1
                            },
                            disableArrow: true,
                            children: section === null || section === void 0 ? void 0 : section.testimonials.map(function(testimonial, i) {
                                var ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            className: (Styles_module_default()).testimonialTitle,
                                            children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.quote
                                        }),
                                        (testimonial === null || testimonial === void 0 ? void 0 : testimonial.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Styles_module_default()).testimonialNameContainer,
                                            children: [
                                                (testimonial === null || testimonial === void 0 ? void 0 : testimonial.photo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: (Styles_module_default()).testimonialImage,
                                                    src: testimonial === null || testimonial === void 0 ? void 0 : (ref = testimonial.photo) === null || ref === void 0 ? void 0 : ref.url,
                                                    alt: "Testimonial Image",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Styles_module_default()).testimonialNameContent,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            className: (Styles_module_default()).testimonialName,
                                                            children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            className: (Styles_module_default()).testimonialRole,
                                                            children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.role
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Styles_module_default()).testimonialLogo,
                                                    children: (testimonial === null || testimonial === void 0 ? void 0 : testimonial.logo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: (Styles_module_default()).agencyLogo,
                                                        loading: "lazy",
                                                        src: "/logos/white-cropped/".concat(testimonial.logo, ".svg"),
                                                        alt: testimonial.logo
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        })
                    ]
                })
            }, ind);
    }
};
/* harmony default export */ var Abm_AgencyTestimonialSection = (AgencyTestimonialSection);

;// CONCATENATED MODULE: ./src/components/Abm/CaseMetricSection.jsx






var CaseMetricSection = function(param) {
    var section = param.section, ind = param.ind;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classnames_default()((Styles_module_default()).container, (Styles_module_default()).caseMetricContainer),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    className: (Styles_module_default()).sectionTitle,
                    children: section === null || section === void 0 ? void 0 : section.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Styles_module_default()).caseMetricSection,
                    children: section === null || section === void 0 ? void 0 : section.caseMetrics.map(function(data, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: (Styles_module_default()).caseMetric,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    className: (Styles_module_default()).metricValue,
                                    children: data === null || data === void 0 ? void 0 : data.value
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    className: (Styles_module_default()).metricDescription,
                                    children: data.description
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    }, ind);
};
/* harmony default export */ var Abm_CaseMetricSection = (CaseMetricSection);

;// CONCATENATED MODULE: ./src/components/Abm/DefaultSection.jsx





var DefaultSection = function(param) {
    var section = param.section, ind = param.ind;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: (Styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                className: (Styles_module_default()).sectionTitle,
                children: section.type
            })
        })
    }, ind);
};
/* harmony default export */ var Abm_DefaultSection = (DefaultSection);

;// CONCATENATED MODULE: ./src/pages/[[...slug]].jsx






















var isDark = function(bgColor) {
    if (!bgColor) {
        return "initial";
    }
    // This could be css-only https://css-tricks.com/switch-font-color-for-different-backgrounds-with-css/
    var color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "initial" : "#fff";
};
var getSection = function(section, ind) {
    switch(section.type){
        case "AgencyLogoSection":
            var isScheduleCallSection = !!(section.scheduleCallSectionSubtitle && section.scheduleCallLogoHeading);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AgencyLogoSection/* default */.Z, {
                section: section,
                isScheduleCallSection: isScheduleCallSection
            }, ind);
        case "AgencyTestimonialSection":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abm_AgencyTestimonialSection, {
                section: section
            }, ind);
        case "AgencyCaseSection":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abm_AgencyCaseSection, {
                section: section
            }, ind);
        case "AgencyCardSection":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abm_AgencyCardSection, {
                section: section
            }, ind);
        case "AgencyTalentsSection":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abm_AgencyTalentsSection, {
                section: section
            }, ind);
        case "AgencyInsightsSection":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abm_AgencyInsightsSection, {
                section: section
            }, ind);
        case "AgencyLearnSection":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abm_AgencyLearnSection, {
                section: section
            }, ind);
        case "AgencyCtaSection":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abm_AgencyCtaSection, {
                section: section
            }, ind);
        case "CaseMetricSection":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abm_CaseMetricSection, {
                section: section
            }, ind);
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abm_DefaultSection, {
                section: section
            }, ind);
    }
};
var EnterpriseAgencyPage = function(param) {
    var propHead = param.head, title = param.title, description = param.description, sections = param.sections, featuredImage = param.featuredImage, featuredVideo = param.featuredVideo, propPrivate = param.private, footer = param.footer, // analyticsData,
    accentColor1 = param.accentColor1, accentColor2 = param.accentColor2;
    (0,react.useEffect)(function() {
        var rootStyle = document.querySelector(":root").style;
        if (accentColor1 === null || accentColor1 === void 0 ? void 0 : accentColor1.hex) {
            rootStyle.setProperty("--accentColorPrimaryBackground", accentColor1 === null || accentColor1 === void 0 ? void 0 : accentColor1.hex);
            rootStyle.setProperty("--accentColorPrimaryText", isDark(accentColor1 === null || accentColor1 === void 0 ? void 0 : accentColor1.hex));
        }
        if (accentColor2 === null || accentColor2 === void 0 ? void 0 : accentColor2.hex) {
            rootStyle.setProperty("--accentColorSecondaryBackground", accentColor2 === null || accentColor2 === void 0 ? void 0 : accentColor2.hex);
            rootStyle.setProperty("--accentColorSecondaryText", isDark(accentColor2 === null || accentColor2 === void 0 ? void 0 : accentColor2.hex));
        }
    }, [
        accentColor1 === null || accentColor1 === void 0 ? void 0 : accentColor1.hex,
        accentColor2 === null || accentColor2 === void 0 ? void 0 : accentColor2.hex
    ]);
    var head = propHead || {};
    if (!head.title) head.title = "".concat(title, " | Poly");
    if (!head.meta) head.meta = [];
    if (propPrivate) {
        head.meta.push({
            name: "robots",
            content: "noindex"
        }, {
            name: "description",
            content: "XXXX"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* default */.Z, {
        className: (Styles_module_default()).baseLayout,
        pageHead: head,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Styles_module_default()).mediaIndicator
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(videoLazyload/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AbmHeader/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: (Styles_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
                    className: (Styles_module_default()).heroSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            element: "h1",
                            className: (Styles_module_default()).title,
                            children: (title === null || title === void 0 ? void 0 : title.text) || title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            element: "p",
                            className: (Styles_module_default()).description,
                            children: description
                        }),
                        featuredVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Styles_module_default()).featuredImageContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                className: classnames_default()("lazy", (Styles_module_default()).featuredImage),
                                autoPlay: true,
                                muted: true,
                                loop: true,
                                playsInline: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    "data-src": featuredVideo === null || featuredVideo === void 0 ? void 0 : featuredVideo.url
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Styles_module_default()).featuredImageContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: (Styles_module_default()).featuredImage,
                                src: featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.url,
                                width: featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.width,
                                height: featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.height,
                                alt: "heroImage",
                                priority: true
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: sections.map(function(section, index) {
                    return getSection(section, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientFooter/* default */.Z, {
                footer: footer
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (EnterpriseAgencyPage);


/***/ }),

/***/ 8456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JP": function() { return /* binding */ COOKIE_DOMAIN; },
/* harmony export */   "e7": function() { return /* binding */ months; }
/* harmony export */ });
/* unused harmony exports getName, formatBytes, acceptedFiles, parseCookie, censorString, replaceJson, isValidImage, removeNullProps, skipStaticBuild */
/* provided dependency */ var process = __webpack_require__(7061);


var getName = function(url) {
    if (url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }
    return;
};
var formatBytes = function(bytes) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    if (bytes === 0) return "0 Bytes";
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};
var acceptedFiles = (/* unused pure expression or super */ null && ([
    "image/*",
    "application/zip",
    "application/pdf",
    "video/*",
    "application/vnd.ms-excel",
    "application/vnd.oasis.opendocument.text",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/docx",
    "application/doc",
    "text/plain",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
]));
var COOKIE_DOMAIN = {
    domain:  true ? "127.0.0.1" : 0,
    httpOnly: false,
    sameSite: false,
    path: "/"
};
var parseCookie = function(str) {
    if (!str) {
        return {};
    }
    return str.split(";").map(function(v) {
        return v.split("=");
    }).reduce(function(acc, v) {
        acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
        return acc;
    }, {});
};
// export const isOfTypeUuId = (value) => {
//   const accessKeyRegex =
//     /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
//   return accessKeyRegex.test(value);
// };
// export const toReadableDate = (date, fmt) => {
//   return format(new Date(date), fmt || 'dd MMM yyyy');
// };
// export const dateSort = (a, b) => {
//   const bEnd = b.endYear ? new Date(b.endYear, b.endMonth).valueOf() : new Date().valueOf();
//   const aEnd = a.endYear ? new Date(a.endYear, a.endMonth).valueOf() : new Date().valueOf();
//   return bEnd < aEnd ? -1 : 1;
// };
// export const setValue = (entry, value) => {
//   if (entry === undefined) {
//     // eslint-disable-next-line
//     console.warn({ err: new Error('entry is undefined on setValue') });
//     return '';
//   }
//   // eslint-disable-next-line
//   entry = entry.replace(/(\{(\w+)\})/g, (match, grp, key) => {
//     const ret = value[key];
//     if (ret !== null && ret !== undefined) {
//       return ret;
//     }
//     return match;
//   });
//   return entry;
// };
//
// testing a replacement for date-fns format. To check if we can remove it from every page load
// Will replace with verbose but plain JS
// format(new Date(), 'MMM yyyy'),
//
var getRandomLetter = function(length) {
    var randomChars = "abcdefghijklmnopqrstuvwxyz";
    return randomChars.charAt(Math.floor(Math.random() * randomChars.length));
};
var censorString = function(input) {
    var randomized = input.split("").sort(function() {
        return 0.5 - Math.random();
    }).join("");
    return randomized.charAt(0).toUpperCase() + randomized.slice(1);
};
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec", 
];
var replaceJson = function(jsonFile, count) {
    var entry = JSON.stringify(jsonFile);
    var today = new Date();
    var replacement = {
        siteName: "Poly",
        contactEmail: "".concat("contact@wearepolystudios.com"),
        month: "".concat(months[today.getUTCMonth()], " ").concat(today.getFullYear()),
        count: "".concat(count)
    };
    // const replacementKeys = Object.keys(replacement);
    entry = entry.replace(/(\{(\w+)\})/g, function(match, grp, key) {
        var ret = replacement[key];
        if (ret !== null && ret !== undefined) {
            return ret;
        }
        return match;
    });
    return JSON.parse(entry);
};
var isValidImage = function(imageUrl) {
    return imageUrl.match(/\.(jpeg|JPEG|JPG|GIF|PNG|svg|SVG|WEBP|webp|jpg|gif|png)$/) != null;
};
var removeNullProps = function(obj) {
    var returnObj = {};
    Object.entries(obj).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), idx = _param[0], v = _param[1];
        if (Array.isArray(v)) {
            if (v.length) returnObj[idx] = v;
        } else {
            if (!!v) returnObj[idx] = v;
        }
    });
    return returnObj;
};
var skipStaticBuild = process.env.SKIP_STATIC_BUILD === "true" || process.env.SKIP_STATIC_BUILD === true;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [327,87,576,903,240,591,538,45,391,774,888,179], function() { return __webpack_exec__(561); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);